import { Box, Typography, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const MainErrorFallback = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        color: 'error.main',
      }}
      role='alert'>
      <ErrorOutlineIcon sx={{ fontSize: 60, mb: 2 }} />
      <Typography
        variant='h5'
        fontWeight={600}>
        エラーが発生しました
      </Typography>
      <Typography
        variant='body1'
        color='text.secondary'
        sx={{ mt: 1 }}>
        申し訳ありません。予期せぬ問題が発生しました。
      </Typography>
      <Button
        variant='contained'
        color='primary'
        sx={{ mt: 4 }}
        onClick={() => window.location.assign(window.location.origin)}>
        更新する
      </Button>
    </Box>
  )
}
